(function () {
  'use strict';

  const STORAGE_KEY = 'dawn_sample_added';

  // ── Reset flag when cart becomes empty ────────────────────────────────
  function resetFlagIfCartEmpty() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        if (cart.item_count === 0) {
          sessionStorage.removeItem(STORAGE_KEY);
          console.log('[Sample Cart] Cart is empty — flag reset.');
        }
      });
  }

  // Check on every page load
  resetFlagIfCartEmpty();

  // Also watch for Dawn's cart update events (fires when items are removed)
  document.addEventListener('cart:updated', resetFlagIfCartEmpty);
  document.addEventListener('cart-update', resetFlagIfCartEmpty);

  // Watch Dawn's internal PUB_SUB by observing cart drawer DOM changes
  const cartDrawerObserver = new MutationObserver(() => {
    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl && cartDrawerEl.classList.contains('is-empty')) {
      sessionStorage.removeItem(STORAGE_KEY);
      console.log('[Sample Cart] Cart drawer went empty — flag reset.');
    }
  });

  // Start observing once DOM is ready
  function startObserver() {
    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      cartDrawerObserver.observe(cartDrawerEl, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  // ── Toast ──────────────────────────────────────────────────────────────
  function showToast(message) {
    let toast = document.getElementById('sample-toast');
    if (toast) toast.remove();

    toast = document.createElement('div');
    toast.id = 'sample-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none"
           viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
      </svg>
      <span>${message}</span>
      <a href="/cart">View cart →</a>
    `;
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('sample-toast--visible'));
    setTimeout(() => {
      toast.classList.remove('sample-toast--visible');
      toast.addEventListener('transitionend', () => toast.remove(), { once: true });
    }, 3500);
  }

  // ── Patch at the CLASS prototype level ────────────────────────────────
  function patchPrototype() {
    const CartDrawerClass = customElements.get('cart-drawer');
    if (!CartDrawerClass) return false;
    if (CartDrawerClass.prototype.__samplePatched) return true;
    if (typeof CartDrawerClass.prototype.renderContents !== 'function') return false;

    const originalRenderContents = CartDrawerClass.prototype.renderContents;

    CartDrawerClass.prototype.renderContents = function (parsedState) {
      const isSamplePage = !!document.querySelector('[data-sample-product]');

      if (isSamplePage) {
        const hasAddedBefore = sessionStorage.getItem(STORAGE_KEY);

        if (!hasAddedBefore) {
          // First sample — open drawer normally
          sessionStorage.setItem(STORAGE_KEY, '1');
          originalRenderContents.call(this, parsedState);
        } else {
          // 2nd+ sample — suppress drawer, show toast
          const originalOpen = this.open;
          this.open = function () {};
          originalRenderContents.call(this, parsedState);
          requestAnimationFrame(() => {
            this.open = originalOpen;
          });
          showToast('Sample added to your cart!');
        }
      } else {
        originalRenderContents.call(this, parsedState);
      }
    };

    CartDrawerClass.prototype.__samplePatched = true;
    console.log('[Sample Cart] Prototype patched successfully.');
    return true;
  }

  // ── Wait for class to be registered, then patch ───────────────────────
  function waitAndPatch() {
    if (patchPrototype()) return;

    customElements.whenDefined('cart-drawer').then(() => {
      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;
        if (patchPrototype()) {
          clearInterval(interval);
          startObserver(); // start watching cart-drawer class changes
        } else if (attempts > 60) {
          clearInterval(interval);
          console.warn('[Sample Cart] Could not patch — CartDrawer prototype never ready.');
        }
      }, 50);
    });
  }

  // Also start observer after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      startObserver();
      waitAndPatch();
    });
  } else {
    startObserver();
    waitAndPatch();
  }

})();